import { resolveValue } from './parser'

export function reemplazarImagenes(xml, datos, zip, xmlFileName) {
  // relsPath es la relación entre los xml 
  // Ejemplo: xmlFileName = 'document.xml', 'header1.xml', 'footer1.xml'
  const relsPath = `word/_rels/${xmlFileName}.rels`

  // Si no existe, crear estructura básica
  let relsXml = zip.file(relsPath)
    ? zip.file(relsPath).asText()
    : '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
      '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"></Relationships>'

  // calcular el índice inicial (el máximo Id existente rIdN)
  const usedRels = [...relsXml.matchAll(/Id="rId(\d+)"/g)].map((m) => parseInt(m[1], 10))
  let relsIndex = usedRels.length ? Math.max(...usedRels) : 0

  const placeholderRegex = /\$\{i:([^}]+)\}/g
  let resultado = ''
  let lastIndex = 0

  while (true) {
    const phMatch = placeholderRegex.exec(xml)
    if (!phMatch) break

    const placeholderStart = phMatch.index
    const placeholderEnd = placeholderRegex.lastIndex

    // Buscar inicio del <w:r> más cercano hacia atrás
    const antesPlaceholder = xml.slice(0, placeholderStart)
    const startWR = antesPlaceholder.lastIndexOf('<w:r>')
    if (startWR === -1) continue

    // Buscar cierre del </w:r> más cercano hacia adelante
    const despuesPlaceholder = xml.slice(placeholderEnd)
    const endWRRel = despuesPlaceholder.indexOf('</w:r>')
    if (endWRRel === -1) continue
    const endWR = placeholderEnd + endWRRel + '</w:r>'.length

    // Extraemos info del placeholder
    let [path, size] = phMatch[1].split(',').map((s) => s.trim())
    const base64 = resolveValue(datos, path)
    if (!base64) {
      resultado += xml.slice(lastIndex, startWR) + '<w:r></w:r>'
      lastIndex = endWR
      continue
    }

    const tipo = base64.match(/^data:(image\/[a-zA-Z]+);base64,/)?.[1] || 'image/png'
    let extension = (tipo.split('/')[1] || 'png').toLowerCase()
    if (extension === 'jpeg') extension = 'jpg'
    const contenido = base64.split(',')[1] || ''

    relsIndex++
    const rId = 'rId' + relsIndex
    const imageName = `image${relsIndex}.${extension}`

    // Guardar imagen en la carpeta media
    zip.file(`word/media/${imageName}`, contenido, { base64: true })

    // Agregar relación al .rels de este XML específico
    const relXml = `<Relationship Id="${rId}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/${imageName}"/>`
    relsXml = relsXml.replace('</Relationships>', `${relXml}\n</Relationships>`)

    // Tamaño en EMUs
    let cx = 2000000,
      cy = 500000
    if (size) {
      const [w, h] = size.split('x').map((n) => parseFloat(n) || 0)
      cx = Math.round(w * 9525)
      cy = Math.round(h * 9525)
    }

    const drawingRun = `
      <w:r>
        <w:drawing>
          <wp:inline distT="0" distB="0" distL="0" distR="0"
            xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing">
            <wp:extent cx="${cx}" cy="${cy}"/>
            <wp:effectExtent l="0" t="0" r="0" b="0"/>
            <wp:docPr id="${relsIndex}" name="Picture ${relsIndex}"/>
            <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"
                       xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
              <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
                <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                  <pic:blipFill>
                    <a:blip r:embed="${rId}"/>
                    <a:stretch><a:fillRect/></a:stretch>
                  </pic:blipFill>
                  <pic:spPr>
                    <a:xfrm>
                      <a:off x="0" y="0"/>
                      <a:ext cx="${cx}" cy="${cy}"/>
                    </a:xfrm>
                    <a:prstGeom prst="rect"><a:avLst/></a:prstGeom>
                  </pic:spPr>
                </pic:pic>
              </a:graphicData>
            </a:graphic>
          </wp:inline>
        </w:drawing>
      </w:r>
    `.trim()

    resultado += xml.slice(lastIndex, startWR) + drawingRun
    lastIndex = endWR
  }

  resultado += xml.slice(lastIndex)
  zip.file(relsPath, relsXml)

  return resultado
}
